<template>
  <div id="app" @click="clicked">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>
<script>
  export default {
    provide () {
      return {
        reload: this.reload
      }
    },
    data () {
      return {
        isRouterAlive: true
      }
    },
    methods: {
      reload () {
        this.isRouterAlive = false
        this.$nextTick(() => {
          this.isRouterAlive = true
        })
      },
      clicked () {
        this.$store.commit('common/getClickTime', new Date().getTime())
      }
    }
  }
</script>
<style lang="less">
#app {
  font-family: sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
</style>
